import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';

import { Lesson, LessonAvailability, LessonBulkCreateInput } from './lesson.model';
import { MessageNotification } from './lesson.message.model';
import { DateUtils } from 'ng-jhipster';
import { AbstractEntityService } from '../../shared/service/abstract-entity.service';
import { Reservation } from '../reservation';

@Injectable()
export class LessonService extends AbstractEntityService {

    protected resourceUrl = 'api/lessons';
    private resourceSearchUrl = 'api/_search/lessons';
    private resourceSearchNoAuthUrl = 'api/no-auth/_search/lessons';
    protected resourceCountUrl = 'api/_search/count/lessons';
    private resourceBulkUrl = this.resourceUrl + '/bulk';

    constructor(protected http: HttpClient, private dateUtils: DateUtils) { super(http); }

    create(lesson: Lesson): Observable<Lesson> {
        let copy: Lesson = Object.assign({}, lesson);
        copy.begining = this.dateUtils.toDate(lesson.begining);
        copy.ending = this.dateUtils.toDate(lesson.ending);
        copy.free = copy.free ? copy.free : false;
        return this.http.post<Lesson>(this.resourceUrl, copy).map((res: Lesson) => {
            return res;
        });
    }

    bulkCreate(lesson: Lesson, toDate: any,  bulkCreateParameters: {}): Observable<any> {
        let copy: Lesson = Object.assign({}, lesson);
        copy.begining = this.dateUtils.toDate(lesson.begining);
        copy.ending = this.dateUtils.toDate(lesson.ending);
        copy.free = copy.free ? copy.free : false;

        return this.http
                   .post(this.resourceBulkUrl , new LessonBulkCreateInput(copy,
                    this.dateUtils.convertLocalDateToServer(toDate),
                    bulkCreateParameters['createInUnavailableDays'],
                    bulkCreateParameters['createInMondays'],
                    bulkCreateParameters['createInTuesdays'],
                    bulkCreateParameters['createInWednesdays'],
                    bulkCreateParameters['createInThursdays'],
                    bulkCreateParameters['createInFridays'],
                    bulkCreateParameters['createInSaturdays'],
                    bulkCreateParameters['createInSundays']), {responseType: 'text'}
                    )
                   .map((res: any) => {
                       return res;
                   });
    }

    update(lesson: Lesson): Observable<Lesson> {
        let copy: Lesson = Object.assign({}, lesson);

        return this.http.put<Lesson>(this.resourceUrl, copy).map((res: Lesson) => {
            return res;
        });
    }

    bulkUpdate(lesson: Lesson): Observable<Lesson> {
        let copy: Lesson = Object.assign({}, lesson);

        return this.http.put<Lesson>(this.resourceBulkUrl, copy).map((res: Lesson) => {
            return res;
        });
    }

    bulkDelete(id: number): Observable<string> {
        return this.http.delete(`${this.resourceBulkUrl}/${id}`, {responseType: 'text'});
    }

    cancel(lesson: Lesson, sendNotifications: boolean): Observable<Lesson> {
        let copy: Lesson = Object.assign({}, lesson);

        if (sendNotifications) {
            return this.http.put<Lesson>(this.resourceUrl + '?params=sendNotifications', copy).map((res: Lesson) => {
                return res;
            });
        } else {
            return this.http.put<Lesson>(this.resourceUrl, copy).map((res: Lesson) => {
                return res;
            });
        }
    }

    find(id: number): Observable<Lesson> {
        return this.http.get<Lesson>(`${this.resourceUrl}/${id}`).map((res: Lesson) => {
            let jsonResponse = res;
            jsonResponse.begining = this.dateUtils
                .convertDateTimeFromServer(jsonResponse.begining);
            jsonResponse.ending = this.dateUtils
                .convertDateTimeFromServer(jsonResponse.ending);
            return jsonResponse;
        });
    }

    sendMessage(message: MessageNotification): Observable<string> {
        return this.http.post(`${this.resourceUrl}/notifications`, message,  {responseType: 'text'})
            .map((res: string) => {
               return res;
            });
    }

    getLastCancellationDate(lesson: Lesson): Date {
        if (lesson) {
            let lastCancellationDate: Date = new Date(lesson.begining);
            return lesson.reservationCancellationPolicy ?
                lastCancellationDate.setHours(lastCancellationDate.getHours() - lesson.reservationCancellationPolicy) : lesson.begining;
        }
        return new Date();
    }

    getDefaultValueForPublished(lesson: Lesson): boolean {
        // The videoConferenceUrl is automatically published if there is a value for that field
        return lesson.videoConferenceUrl ? true : false;
    }

    getReservations(id: number): Observable<HttpResponse<Reservation[]>> {
        let options = this.createRequestOption(null, true);
        return this.http.get<HttpResponse<Reservation[]>>(`${this.resourceUrl}/${id}/reservations`, options)
            .map((res: HttpResponse<Reservation[]>) => this.convertReservationsResponse(res));
    }

    query(req?: any): Observable<HttpResponse<Lesson[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<Lesson[]>>(this.resourceUrl, options)
            .map((res: HttpResponse<Lesson[]>) => this.convertResponse(res))
            ;
    }

    search(req?: any): Observable<HttpResponse<Lesson[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<Lesson[]>>(this.resourceSearchUrl, options)
            .map((res: HttpResponse<Lesson[]>) => this.convertResponse(res))
            ;
    }

    searchNoAuth(req?: any): Observable<HttpResponse<Lesson[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<Lesson[]>>(this.resourceSearchNoAuthUrl, options)
            .map((res: HttpResponse<Lesson[]>) => this.convertResponse(res))
            ;
    }

    private convertResponse(res: HttpResponse<Lesson[]>): any {
        let jsonResponse = res.body;
        for (let i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].begining = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].begining);
            jsonResponse[i].ending = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].ending);
        }
        return res.clone({body: jsonResponse});
    }

    private convertReservationsResponse(res: any): any {
        let jsonResponse = res.body;

        for (const reservation of jsonResponse) {
            if (reservation.student && reservation.student.status) {
            // Calculate the financial status of the student
                reservation.student.paidPercentage = reservation.student.status.total
                    ? Math.trunc((reservation.student.status.totalPaid * 100) / reservation.student.status.total)
                    : 100;
            }
        }

        res._body = jsonResponse;

        return res;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/lesson/lesson.service.ts